import { cva } from 'class-variance-authority';

export const icon = cva('inline-flex', {
  variants: {
    size: {
      large: 'h-[32px] w-[56px]',
      medium: 'h-[24px] w-[42px]',
      small: 'h-[20px] w-[35px]',
    },
    color: {
      darkgreen: 'text-color-efficiency-darkgreen',
      mediumgreen: 'text-color-efficiency-mediumgreen',
      lightgreen: 'text-color-efficiency-lightgreen',
      yellow: 'text-color-efficiency-yellow',
      lightorange: 'text-color-efficiency-lightorange',
      darkorange: 'text-color-efficiency-darkorange',
      red: 'text-color-efficiency-red',
    },
  },
});
